module.exports = __webpack_public_path__ + "static/media/play2-gray.d736beb4.svg";